import styles from './StockStatus.module.scss'
import { IArticlePriceStockModel } from '@/types/api'
import { useStock } from '@/utils/hooks/useStock'
import React from 'react'
import InStockIcon from '@/assets/svg/instock.svg'
import ToOrderIcon from '@/assets/svg/toorder.svg'
import OnPurchaseIcon from '@/assets/svg/onpurchase.svg'
import classNames from 'classnames'
import { roboto } from '@/utils/fonts'
import { useCustomer } from '@/utils/hooks/useCustomer'

type Props = {
  article: IArticlePriceStockModel,
  className?: string,
  light?: boolean,
}
const StockStatus = (props: Props) => {
  const { isReseller } = useCustomer()
  const { stockStatus, stockText } = useStock(props.article, isReseller)

  const stockStatusClass = classNames(
    styles.component,
    props.className,
    {
      [styles.light]: props.light,
    }
  )
  
  const stockStatusTextClass = styles[stockStatus]

  return (
    <div className={stockStatusClass}>
      <div className={styles.icon}>
        {stockStatus === 'InStock' && <InStockIcon />}
        {stockStatus === 'ToOrder' && <ToOrderIcon />}
        {stockStatus === 'OnPurchase' && <OnPurchaseIcon />}
        {stockStatus === 'OutOfStock' && <ToOrderIcon />}
      </div>
      <div className={classNames(styles.text, roboto.className, stockStatusTextClass)}>
        {stockText}
      </div>
    </div>
  )
}

export default StockStatus